import React from 'react';
import { Toggle } from 'ui';
import ListFlowPanel from '~/components/ListFlow/Elements/ListFlowPanel';

interface Props {
  disabled?: boolean;
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
  title: React.ReactNode;
}

const ListFlowExpandablePanel: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  disabled,
  expanded,
  setExpanded,
  title,
}) => (
  <ListFlowPanel
    title={
      <>
        <div className="mr-4">{title}</div>
        <Toggle
          disabled={disabled}
          size="large"
          onChange={setExpanded}
          value={expanded}
        />
      </>
    }
  >
    {expanded && <div className="mt-2">{children}</div>}
  </ListFlowPanel>
);

export default ListFlowExpandablePanel;
